const RootIds = /* @__PURE__ */ new WeakMap();
let counter = 0;
function getRootId(root) {
  if (!root) return "0";
  RootIds.set(root, RootIds.get(root) ?? `${++counter}`);
  return RootIds.get(root);
}
export {
  getRootId
};
//# sourceMappingURL=getRootId.js.map
